export enum ErrorLayoutType {
    Default = 'default',
    AuthFailed = 'auth-failed',
    NoAccessInFederation = 'no-access-in-federation',
}

export enum ApiService {
    Iam = 'iam',
    OrganizationManager = 'organizationManager',
}

export const SETTINGS_PAGE_PATH = '/_settings';

// Переeзжать аккуратно, могут быть проблемы из-за разного кейса
export enum Header {
    AcceptLanguage = 'accept-language',
    Accept = 'accept',
    Authorization = 'authorization',

    CacheControl = 'cache-control',

    ContentType = 'content-type',
    ContentLength = 'content-length',

    Cookie = 'cookie',
    Host = 'host',

    Pragma = 'pragma',
    LastModified = 'last-modified',
    ifModifiedSince = 'if-modified-since',

    xReqId = 'x-req-id',
    xRealIp = 'x-real-ip',
    xUserIp = 'x-user-ip',
    xNginxHost = 'x-nginx-host',
    xRequestId = 'x-request-id',
    xForwardedFor = 'x-forwarded-for',

    xOrgId = 'x-org-id',
    xUid = 'x-uid',
    xCloudUid = 'x-cloud-uid',

    xYaUserTicket = 'x-ya-user-ticket',
    xYaServiceTicket = 'x-ya-service-ticket',

    xYaCloudUserTicket = 'x-ya-cloud-user-ticket',

    xYacloudSubjectToken = 'x-yacloud-subjecttoken',

    xWikiSecret = 'x-wiki-secret',
    DumpsTestPath = 'dumps_test_path',

    xCollabOrgId = 'x-collab-org-id',
    xExperiment = 'x-experiment',
}

export enum GatewayInstallation {
    Russia = 'russia',
    YandexTeam = 'yandex-team',
    NoType = 'notype',
}

export enum GatewayEnv {
    Prod = 'prod',
    Preprod = 'preprod',
    Mock = 'mock',
    NoEnv = 'noenv',
}

export enum ExperimentKey {
    IMain = 'imain',
    NewGrids = 'new-grids',
    Bem = 'bem',
    Proxy = 'proxy',
    Com = 'com',
    ComOrg = 'com-org',
    Collab = 'collab',
    Collab2 = 'collab2',
    WysiwygDefault = 'wysiwyg-default',
    WikiYfmConvert = 'wiki-yfm-convert',
    InlineComments = 'inline-comments',
    // For tests
    DataUi = 'data-ui',
}
